//
// NOTE: Use this file and create the `environment.ts`
//
// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const _environment = {
	production: false,
	app: {
		name: 'Firefront',
		subtitle: 'Firebase Admin',
		slogan: 'Your Firebase Admin Panel'
	},
	databaseType: 'realtime', // cloud-firestore || realtime
	fire: {
		auth: {
			apiKey: 'AIzaSyAY8dIAVW6jZ8sSoYPQLRQOp-sUeYnYfWw',
			authDomain: 'firefront-stage.firebaseapp.com',
			databaseURL: 'https://firefront-stage.firebaseio.com',
			projectId: "firefront-stage",
			storageBucket: 'firefront-stage.appspot.com',
			messagingSenderId: '199004235280'
		}
	},
	s3: {
		accessKeyId: 'AKIAJQ6JQDWWVL66S4PA',
		secretAccessKey: 'Sa1FR3Y8Ca9doOBJj4DXAsJUOMYouRDQ/zLStyZ+',
		bucket: 'dev.appseed.io/mobile-apps/businessdirectory-frb-admin'
	},
	maps: {
		apiKey: 'AIzaSyB3c6WmfOf9_Dd_Sh1gC2n7MjyGrUYPiSw'
	},
	components: {
		active: ['landingpages']
	}
};

export const environment = {
    production: true,
    databaseType: 'realtime', // cloud-firestore || realtime
    app: {
            name: 'Firefront',
            subtitle: 'Firebase Admin',
            slogan: 'Your Firebase Admin Panel'
    },
    fire: {
            auth: {
                apiKey: 'AIzaSyAY8dIAVW6jZ8sSoYPQLRQOp-sUeYnYfWw',
                authDomain: 'firefront-stage.firebaseapp.com',
                databaseURL: 'https://firefront-stage.firebaseio.com',
                projectId: 'firefront-stage',
                storageBucket: 'firefront-stage.appspot.com',
                messagingSenderId: '199004235280'
            }
    },
    s3: {
        accessKeyId: 'AKIAJQ6JQDWWVL66S4PA',
        secretAccessKey: 'Sa1FR3Y8Ca9doOBJj4DXAsJUOMYouRDQ/zLStyZ+',
        bucket: 'dev.appseed.io/mobile-apps/businessdirectory-frb-admin'
     },
     maps: {
        apiKey: 'AIzaSyB3c6WmfOf9_Dd_Sh1gC2n7MjyGrUYPiSw'
    },
		components: {
			active: ['landingpages']
		},
    unlayer: {
        endpointUrl: 'https://api.unlayer.com/v1',
        // token: 'k8GMI9r3YL6w8jHhFK4r2WnoNK1Le4svBnjeZpEIu1paqBwNID8e4YrA0FvwM2lj:' // Playground
				token: '4hpIkEvrfb6Jm0HYIevMNkg8Xsbm0c9Om2weMfI7Tpi4UAthmb0yPr5fDiiYsntV' // Foo
    }
};


// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses environment.ts, but if you do
// ng build --env=prod then environment.prod.ts will be used instead.
// The list of which env maps to which file can be found in .angular-cli.json.
